import { useEffect, useState } from 'react';
import FlightsListView from './FlightsListView';
import FlightsAsideFilters from 'frontend/components/flights/AsideFilters/FlightsAsideFilter';
import MobileFlightsFilter from 'frontend/components/flights/AsideFilters/MobileAsideFilters';
import { Stack } from '@mui/material';
import { FlightsFiltersProvider } from 'frontend/contexts/FlightsFiltersContext';

const FlightListPage = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768 ? true : false);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <FlightsFiltersProvider>
      <Stack
        direction="row"
        display="flex"
        sx={{
          paddingX: {
            xs: 0,
            sm: 2,
            md: 6,
            lg: '5%',
          },
          marginBottom: '3rem',
        }}
      >
        {!isMobile ? (
          <FlightsAsideFilters />
        ) : (
          <MobileFlightsFilter>
            <FlightsAsideFilters isMobile />
          </MobileFlightsFilter>
        )}
        <FlightsListView />
      </Stack>
    </FlightsFiltersProvider>
  );
};

export default FlightListPage;
